import _ from 'lodash';
import { action, observable } from 'mobx';

export enum SorterDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

type SortCriteria<T> = [keyof T, SorterDirection];

export class Sorter<T extends Record<string, any> = any> {
    @observable private sortCriteria?: SortCriteria<T>[];

    @observable sort: string[] | undefined;

    constructor(
        private defaultSortCriteria?: SortCriteria<T> | SortCriteria<T>[],
    ) {
        this.defaultSortCriteria = normalizeSortCriteria(defaultSortCriteria);
        this.sortCriteria = this.defaultSortCriteria;
    }

    @action setSorter(sortCriteria: SortCriteria<T> | SortCriteria<T>[]) {
        this.sortCriteria = normalizeSortCriteria(sortCriteria);
        this.updateSort();
    }

    @action reset() {
        this.sortCriteria = this.defaultSortCriteria as SortCriteria<T>[];
        this.updateSort();
    }

    @action updateSort() {
        if (this.sortCriteria) {
            this.sort = this.sortCriteria.map(
                ([field, direction]) => `${String(field)},${direction}`,
            );
        } else {
            this.sort = undefined;
        }
    }
}

export function normalizeSortCriteria<T>(
    sortCriteria?: SortCriteria<T> | SortCriteria<T>[],
): SortCriteria<T>[] | undefined {
    if (!sortCriteria || !_.isArray(sortCriteria) || !sortCriteria?.length) {
        return undefined;
    }

    if (_.isArray(sortCriteria[0])) {
        return sortCriteria as SortCriteria<T>[];
    }

    return [sortCriteria as SortCriteria<T>];
}
